import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

if (getCacConfigByKey('custom.common.uncommonFont', true)) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    import('./uncommon-font.css');
}
